var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "#006EFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91647 14H2.04176C0.915902 14 0 13.0187 0 11.8125V4.40234C0 3.19612 0.915902 2.21484 2.04176 2.21484H6.91647C8.04233 2.21484 8.95824 3.19612 8.95824 4.40234V11.8125C8.95824 13.0187 8.04233 14 6.91647 14ZM2.04176 3.30859C1.47888 3.30859 1.02088 3.79929 1.02088 4.40234V11.8125C1.02088 12.4156 1.47888 12.9062 2.04176 12.9062H6.91647C7.47935 12.9062 7.93735 12.4156 7.93735 11.8125V4.40234C7.93735 3.79929 7.47935 3.30859 6.91647 3.30859H2.04176ZM11 10.4453V2.1875C11 0.981277 10.0841 0 8.95824 0H3.29234C3.0104 0 2.7819 0.244812 2.7819 0.546875C2.7819 0.848938 3.0104 1.09375 3.29234 1.09375H8.95824C9.52112 1.09375 9.97912 1.58444 9.97912 2.1875V10.4453C9.97912 10.7474 10.2076 10.9922 10.4896 10.9922C10.7715 10.9922 11 10.7474 11 10.4453Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.765e61ac3be5467bebee7c744eb0b451.svg";
export { ForwardRef as ReactComponent };